import React, {Component} from "react";
import {Link, Route} from "react-router-dom";
import {ProductTool} from "./productTool";
import DevTool from "./devTool";
import ImportTool from "./importTool";
import OrderTool from "./orderTool";
import ArticleTool from "./articleTool";
import {Button, RelativeSwitch} from "../components/common/common";
import VendorTool from "./vendorTool";
import {reduxWrapper} from "../globalState";
import {ImageTool} from "./imageTool";
import {relativePath} from "../lib/tools";
import BundlesTool from "./bundlesTool";
import SectionOverrideTool from "./SectionOverrideTool";


class AdminViewWrapperRender extends Component {
	
	componentWillMount() {
		this.props.awaitUserData(data => {
			if (data.rle !== "admin") {
				this.props.history.replace("/login");
			}
		});
	}
	
	render() {
		return (
			<div className="adminWrapper">
				<div className="adminContainer whiteContainer">
					<RelativeSwitch>
						
						<Route path="/products" render={() => <ProductTool/>}/>
						<Route path="/orders" render={() => <OrderTool/>}/>
						<Route path="/dev" render={() => <DevTool/>}/>
						<Route exact path="/import/section" render={() => <SectionOverrideTool/>}/>
						<Route path="/import" render={() => <ImportTool/>}/>
						<Route path="/articles" render={() => <ArticleTool/>}/>
						<Route path="/vendors" render={() => <VendorTool/>}/>
						<Route path="/images" render={() => <ImageTool/>}/>
						<Route path="/bundles" render={() => <BundlesTool/>}/>
						<Route render={() => <AdminViewRender/>}/>
					</RelativeSwitch>
				</div>
			</div>
		);
	}
}

export const AdminViewWrapper = reduxWrapper()(AdminViewWrapperRender);

const AdminViewRender = (props) => (
	<div>
		<h1>Admin Console</h1>
		<div className="toolWrapper">
			<ToolContainer name="products" title="Products">
				<ToolSubContainer path="" title="Overview"/>
				<ToolSubContainer path="/new" title="Add new"/>
			</ToolContainer>
			<ToolContainer name="orders" title="Orders">
				<ToolSubContainer path="" title="Overview"/>
			</ToolContainer>
			<ToolContainer name="dev" title="Development">
				<ToolSubContainer path="" title="DB Tool"/>
			</ToolContainer>
			<ToolContainer name="import" title="Import">
				<ToolSubContainer path="/" title="Vendors"/>
				<ToolSubContainer path="/section" title="Section Overrides"/>
			</ToolContainer>
			<ToolContainer name="articles" title="Articles">
				<ToolSubContainer path="" title="Overview"/>
			</ToolContainer>
			<ToolContainer name="vendors" title="Vendors">
				<ToolSubContainer path="" title="Overview"/>
			</ToolContainer>
			<ToolContainer name="bundles" title="Bundles">
				<ToolSubContainer path="" title="Overview"/>
			</ToolContainer>
		</div>
	</div>
);

const ToolContainer = ({title, name, children}) => (
	<div>
		<Link to={`/admin/${name}`}>
			<h3>{title}</h3>
		</Link>
		<ul className="links">
			{React.Children.toArray(children).map(x =>
				React.cloneElement(x, {to: `/${name}${x.props.path}`})
			)}
		</ul>
	</div>
);

const ToolSubContainer = ({to, title}) => (
	<li>
		<Button to={relativePath(to)}>
			{title}
		</Button>
	</li>
);


// WEBPACK FOOTER //
// ./src/admin/adminViewWrapper.js